import { Page } from './types';
import PageHome from 'containers/PageHome/PageHome';
import { FAQPage } from '../containers/FAQPage/FAQPage';
import { ToSPage } from '../containers/ToSPage/ToSPage';
import ListingCarPage from 'containers/ListingCarPage/ListingCarPage';
import ListingCarMapPage from 'containers/ListingCarPage/ListingCarMapPage';
import ListingCarDetailPage from 'containers/ListingDetailPage/listing-car-detail/ListingCarDetailPage';
import PageContact from 'containers/PageContact/PageContact';
import PageAbout from 'containers/PageAbout/PageAbout';
import PageSignUp from 'containers/PageSignUp/PageSignUp';
import PageLogin from 'containers/PageLogin/PageLogin';
import PageSubcription from 'containers/PageSubcription/PageSubcription';
import PageRecoverPassword from '../containers/PageRecoverPassword/PageRecoverPassword';
import PageResetPassword from '../containers/PageResetPassword/PageResetPassword';
import { AuthAction } from '../providers/AuthAction';
import AuthorPage from 'containers/AuthorPage/AuthorPage';
import AccountPage from 'containers/AccountPage/AccountPage';
import AccountSavedServices from 'containers/AccountPage/AccountSavedServices';
import { AccountServiceForm } from '../containers/AccountPage/ServiceForm/AccountServiceForm';
import AccountProviderOrders from '../containers/AccountPage/AccountProviderOrders';
import AccountProviderServices from '../containers/AccountPage/AccountProviderServices';
import AccountPass from 'containers/AccountPage/AccountPass';
import AccountOrders from '../containers/AccountPage/AccountOrders';
import AccountAgenda from '../containers/AccountPage/AccountAgenda';
import AccountReservations from '../containers/AccountPage/AccountReservations';
import ReservationDetailPage from '../containers/AccountPage/ReservationDetailPage';
import { UserTypeEnum } from '@core/enums/UserType.enum';
import CheckOutPage from '../containers/CheckOutPage/CheckOutPage';
import BlogPage from '../containers/BlogPage/BlogPage';
import BlogSingle from '../containers/BlogPage/BlogSingle';
import AccountCompanyOrders from 'containers/AccountCompany/AccountCompanyOrders';
import AccountCompanyLocations from '../containers/AccountCompany/AccountCompanyLocations';
import AccountCompanyProviders from '../containers/AccountCompany/AccountCompanyProviders';
import AccountServices from 'containers/AccountCompany/AccountServices';
import AccountTermsAndConditions from '../containers/AccountCompanySite/AccountTermsAndConditions';
import AccountFAQ from '../containers/AccountCompanySite/AccountFAQ';
import { AccountCompanyBlog } from '../containers/AccountCompanySite/AccountCompanyBlog';
import AccountCompanyUsers from '../containers/AccountPage/AccountCompanyUsers';
import AccountCompanyChats from '../containers/AccountCompanyInteractions/AccountCompanyChats';
import AccountCompanyReviews from 'containers/AccountCompanyInteractions/AccountCompanyReviews';
import AccountCompanyStatistics from '../containers/AccountCompanyInteractions/AccountCompanyStatistics';
import { AccountCompanyPost } from '../containers/AccountCompanySite/AccountCompanyPost';
import OrderDetailPage from '../containers/AccountPage/OrderDetailPage';

export const pages: Page[] = [
  { path: '/', exact: true, component: PageHome },
  { path: '/faq', exact: true, component: FAQPage },
  { path: '/terms-and-conditions', component: ToSPage },
  { path: '/blog', component: BlogPage },
  { path: '/blog/:postId', component: BlogSingle },
  //
  { path: '/listing-car', component: ListingCarPage },
  { path: '/services', component: ListingCarMapPage },
  { path: '/service-detail/:id', component: ListingCarDetailPage },
  //
  { path: '/contact', component: PageContact },
  { path: '/about', component: PageAbout },
  { path: '/signup', component: PageSignUp },
  { path: '/login', component: PageLogin },
  { path: '/subscription', component: PageSubcription },
  { path: '/forgot-password', component: PageRecoverPassword },
  //
  { path: '/auth/action', component: AuthAction },
  { path: '/auth/reset-password', component: PageResetPassword }
];

export const privatePages: Page[] = [
  {
    path: '/author',
    component: AuthorPage,
    allowedRoles: [UserTypeEnum.USER, UserTypeEnum.COMPANY, UserTypeEnum.PROVIDER]
  },
  {
    path: '/account',
    component: AccountPage,
    allowedRoles: [UserTypeEnum.USER, UserTypeEnum.COMPANY, UserTypeEnum.PROVIDER]
  },
  { path: '/account-services', component: AccountServices, allowedRoles: [UserTypeEnum.COMPANY] },
  { path: '/account-services/form', component: AccountServiceForm, allowedRoles: [UserTypeEnum.COMPANY] },
  { path: '/account-provider-orders', component: AccountProviderOrders, allowedRoles: [UserTypeEnum.PROVIDER] },
  { path: '/account-provider-services', component: AccountProviderServices, allowedRoles: [UserTypeEnum.PROVIDER] },
  {
    path: '/account-password',
    component: AccountPass,
    allowedRoles: [UserTypeEnum.USER, UserTypeEnum.COMPANY, UserTypeEnum.PROVIDER]
  },
  {
    path: '/account-saved-services',
    component: AccountSavedServices,
    allowedRoles: [UserTypeEnum.USER, UserTypeEnum.COMPANY, UserTypeEnum.PROVIDER]
  },
  { path: '/account-orders', component: AccountOrders, allowedRoles: [UserTypeEnum.USER] },
  { path: '/account-company-orders', component: AccountCompanyOrders, allowedRoles: [UserTypeEnum.COMPANY] },
  { path: '/account-company-locations', component: AccountCompanyLocations, allowedRoles: [UserTypeEnum.COMPANY] },
  { path: '/account-company-providers', component: AccountCompanyProviders, allowedRoles: [UserTypeEnum.COMPANY] },
  { path: '/account-company-statistics', component: AccountCompanyStatistics, allowedRoles: [UserTypeEnum.COMPANY] },
  { path: '/account-company-chats', component: AccountCompanyChats, allowedRoles: [UserTypeEnum.COMPANY] },
  { path: '/account-company-reviews', component: AccountCompanyReviews, allowedRoles: [UserTypeEnum.COMPANY] },
  { path: '/account-company-users', component: AccountCompanyUsers, allowedRoles: [UserTypeEnum.COMPANY] },
  { path: '/account-company-blog', component: AccountCompanyBlog, allowedRoles: [UserTypeEnum.COMPANY] },
  { path: '/account-company-blog/:postId', component: AccountCompanyPost, allowedRoles: [UserTypeEnum.COMPANY] },
  {
    path: '/account-agenda',
    component: AccountAgenda,
    allowedRoles: [UserTypeEnum.COMPANY, UserTypeEnum.PROVIDER]
  },
  {
    path: '/account-reservations',
    component: AccountReservations,
    allowedRoles: [UserTypeEnum.COMPANY, UserTypeEnum.PROVIDER, UserTypeEnum.USER]
  },
  {
    path: '/account-terms-and-conditions',
    component: AccountTermsAndConditions,
    allowedRoles: [UserTypeEnum.COMPANY]
  },
  {
    path: '/account-faq',
    component: AccountFAQ,
    allowedRoles: [UserTypeEnum.COMPANY]
  },
  {
    path: '/order-detail/:orderId',
    component: OrderDetailPage,
    allowedRoles: [UserTypeEnum.USER, UserTypeEnum.COMPANY, UserTypeEnum.PROVIDER]
  },
  { path: '/checkout', component: CheckOutPage, allowedRoles: [UserTypeEnum.USER] },
  {
    path: '/reservation-detail/:reservationId',
    component: ReservationDetailPage,
    allowedRoles: [UserTypeEnum.USER, UserTypeEnum.COMPANY, UserTypeEnum.PROVIDER]
  },
];
